export enum SyslogAction {
  ADD = "addSyslog",
  EDIT = "editSyslog",
  DUPLICATE = "duplicateSyslog",
  TEST = "testSyslog",
  DISABLE = "disableSyslog",
  ENABLE = "enableSyslog",
  DELETE = "deleteSyslog",
}

export enum SyslogFacility {
  LOCAL0 = "local0",
  LOCAL1 = "local1",
  LOCAL2 = "local2",
  LOCAL3 = "local3",
  LOCAL4 = "local4",
  LOCAL5 = "local5",
  LOCAL6 = "local6",
  LOCAL7 = "local7",
}

export enum SiemErrorType {
  GENERAL_ERROR = "generalError",
  INCORRECT_SIEM_CREDENTIALS = "incorrectSIEMCredentials",
  HOST_RESOLUTION_FAILED = "hostResolutionFailed",
  CONNECTION_TIMED_OUT = "connectionTimedOut",
  CONNECTION_REFUSED = "connectionRefused",
  CONNECTION_RESET = "connectionReset",
  CONNECTION_UNAVAILABLE = "connectionUnavailable",
  CERTIFICATE_FORMAT_ERROR = "certificateFormatError",
  CERTIFICATE_VERIFICATION_FAILED = "certificateVerificationFailed",
  HOST_UNREACHABLE = "hostUnreachable",
}
